import { decode } from 'js-base64';

export const useCsvDownloadNotificationData = (notification = {}) => {
  const { custom_attributes } = notification;

  let data = {};
  try {
    data = JSON.parse(decode(custom_attributes));
  } catch (error) {
    console.error(
      'Error decoding CSV download notification attributes:',
      error
    );
  }

  const {
    provider,
    file_name,
    account_id,
    event_time,
    survey_url,
    records_count,
    csv_export_url,
    form_template_id,
    form_template_name,
  } = data;

  return {
    provider,
    fileName: file_name,
    accountId: account_id,
    eventTime: event_time,
    surveyUrl: survey_url,
    recordsCount: records_count,
    csvExportUrl: csv_export_url,
    formTemplateId: form_template_id,
    formTemplateName: form_template_name,
  };
};
